var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthenticationImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_signing",
    transform: "translate(-481 -300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 300,
    height: 300,
    transform: "translate(481 300)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(298.848 -29.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_signing_illustration",
    transform: "translate(152.57 296.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-75",
    transform: "translate(32.582 63.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M388.17,96.8l53.062-.075s-2.647-3.411-5.553-3.861c0,0-5.683-16.83-15.152-16.932-8.807-.1-12.321,10.376-12.321,10.376s-4.093-4.694-7.982-2.538-6.092,8.3-6.092,8.3S389.753,94.438,388.17,96.8Z",
    transform: "translate(-147.536 -75.929)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M191.422,110.475l-67.1.1s0-4.291,9.237-5.144c0,0,8.412-18.747,21.3-16.25C162.885,90.739,167,101.75,167,101.75s6.051-8.678,10.915-7.006,7.743,10.915,7.743,10.915S190.658,108.087,191.422,110.475Z",
    transform: "translate(-62.994 -80.068)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M349.316,184.563l-45.626.068s4.3-4.011,6.215-4.011,7.5-13.467,14.62-12.907,10.915,10.574,10.915,10.574S344.152,175.557,349.316,184.563Z",
    transform: "translate(-120.441 -105.091)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M73.072,166.884l-39.022.061s1.937-2.531,4.093-2.845c0,0,4.134-12.389,11.1-12.491,6.474-.089,9.08,7.6,9.08,7.6s2.995-3.452,5.867-1.883,4.5,6.092,4.5,6.092S71.9,165.124,73.072,166.884Z",
    transform: "translate(-34.05 -99.979)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-75",
    transform: "translate(74.912 303.298)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 124.83,
    cy: 12.123,
    rx: 124.83,
    ry: 12.123,
    fill: "#7e57c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-75",
    transform: "translate(47.188 37.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M113.5,67.243A28.653,28.653,0,0,1,84.843,95.9C69.009,95.9,55.46,83.063,55.46,67.243S69,37.86,84.829,37.86,113.5,51.409,113.5,67.243Z",
    transform: "translate(-55.46 -37.86)",
    fill: "#f2e15d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(5.239 5.253)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M86.615,93.1A23.482,23.482,0,0,1,63.14,69.628c0-12.962,10.513-24.068,23.475-24.068a24.5,24.5,0,0,1,24.068,24.068C110.683,82.6,99.584,93.1,86.615,93.1Z",
    transform: "translate(-63.14 -45.56)",
    fill: "#f2e15d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 20.023,
    cy: 20.023,
    r: 20.023,
    transform: "translate(9.292 9.305)",
    fill: "#f2e15d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-75",
    transform: "translate(49.439 103.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M143.756,311.169l-3.022,34.254h81.183s-9.067-68.48-9.067-69.08,16.516-21.551,12.894-66.065c-4.53-55.4-43.341-74.518-82.39-74.518s-66.461,36.1-70.267,61.849L58.76,255.6l18.727,2.62s.805,39.268,10.915,49.337S143.756,311.169,143.756,311.169Z",
    transform: "translate(-58.76 -135.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M143.756,311.169l-3.022,34.254h81.183s-9.067-68.48-9.067-69.08,16.516-21.551,12.894-66.065c-4.53-55.4-43.341-74.518-82.39-74.518s-66.461,36.1-70.267,61.849L58.76,255.6l18.727,2.62s.805,39.268,10.915,49.337S143.756,311.169,143.756,311.169Z",
    transform: "translate(-58.76 -135.76)",
    fill: "#f5cec9",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M225.046,215.878c-1.5,6.877-10.615,10.233-10.615,10.233-.559,1.242,2.545,25.494,3.411,26.879s-4.264,4.96-4.939,4.161-6.672-16.578-19.15-19.416h0a20.418,20.418,0,0,1-15.152,7.006c-10.028.246-17.328-6.931-17.328-6.931s-7.074,10.438-21.906,7.743-17.976-14.395-17.976-14.395-19.163,5.792-26.524-9.878c-5.635-11.986.546-20.719,3.739-24.137a16.824,16.824,0,0,1,1.651-1.59h0s-1.583-14.538,7.4-22.158,20.848-6.706,20.848-6.706,4.775-14.715,18.508-17.581,22.049,5.1,22.049,5.1a32.419,32.419,0,0,1,25.924-.136,22.019,22.019,0,0,1,13.822,20.1s10.37,3.411,13.808,11.877-2.183,16.96-2.183,16.96S226.54,209,225.046,215.878Z",
    transform: "translate(-69.509 -139.805)",
    fill: "rgba(224,167,146,0.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(23.075 55.743)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M193.753,259.651h0a20.418,20.418,0,0,1-15.152,7.006c-10.028.246-17.328-6.931-17.328-6.931s-7.074,10.438-21.906,7.743-17.976-14.395-17.976-14.395-19.163,5.792-26.524-9.878c-5.635-11.986.546-20.719,3.739-24.137l1.651-1.59h0c-.089.246-5.335,14.858,3.97,24.007s22.752,3.193,22.752,3.193,1.719,14.463,13.248,17.772c12.805,3.677,21.108-6.058,21.108-6.058S176.309,272.695,193.753,259.651Z",
    transform: "translate(-92.584 -217.47)",
    fill: "#222221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M260.08,297.18c-.682-.791-6.672-16.578-19.15-19.416,0,0,10.233-6.01,14.947-1.8S260.08,297.18,260.08,297.18Z",
    transform: "translate(-116.652 -179.84)",
    fill: "#222221",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M247.785,140.139a4.909,4.909,0,0,1,2.783-.832,1,1,0,0,1,.6,1.439,4.885,4.885,0,0,1-2.094,1.992,4.311,4.311,0,0,1-1.453.416,4.229,4.229,0,0,1-1.712.273H245.8a.13.13,0,0,1-.171-.089l-.1-.034C244.135,142.7,247.253,140.453,247.785,140.139Z",
    transform: "translate(-118.001 -136.878)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M247.785,140.139a4.909,4.909,0,0,1,2.783-.832,1,1,0,0,1,.6,1.439,4.885,4.885,0,0,1-2.094,1.992,4.311,4.311,0,0,1-1.453.416,4.229,4.229,0,0,1-1.712.273H245.8a.13.13,0,0,1-.171-.089l-.1-.034C244.135,142.7,247.253,140.453,247.785,140.139Z",
    transform: "translate(-118.001 -136.878)",
    fill: "#cc7694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M226.838,143.712c-.341.914-.894,2.49-.232,3.411a.348.348,0,0,0,.355.15,1.733,1.733,0,0,0,.955-.73,8.241,8.241,0,0,0,1.89-3c.287-.785-.13-1.958-1.132-1.951S227.117,142.941,226.838,143.712Z",
    transform: "translate(-112.002 -137.613)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M226.838,143.712c-.341.914-.894,2.49-.232,3.411a.348.348,0,0,0,.355.15,1.733,1.733,0,0,0,.955-.73,8.241,8.241,0,0,0,1.89-3c.287-.785-.13-1.958-1.132-1.951S227.117,142.941,226.838,143.712Z",
    transform: "translate(-112.002 -137.613)",
    fill: "#cc7694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M215.768,153.569c.246.764,1.071,1.692,1.583.546a.225.225,0,0,0,0-.2c.682-1.364,1.364-2.831.682-4.359a1.232,1.232,0,0,0-2.183-.252C214.847,150.418,215.365,152.335,215.768,153.569Z",
    transform: "translate(-108.498 -139.891)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M215.768,153.569c.246.764,1.071,1.692,1.583.546a.225.225,0,0,0,0-.2c.682-1.364,1.364-2.831.682-4.359a1.232,1.232,0,0,0-2.183-.252C214.847,150.418,215.365,152.335,215.768,153.569Z",
    transform: "translate(-108.498 -139.891)",
    fill: "#cc7694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M234.26,144.422a12.37,12.37,0,0,1-4.312,1.474c-.293.2-5.1,2.579-6.863,4.045a25.024,25.024,0,0,0-3.227,3.247,33.9,33.9,0,0,1,6.413-3.2,8.8,8.8,0,0,1,6.508-.177c0,.068-2.688,1.255-3.841,1.856s-2.047,1.276-3.145,1.74a12.28,12.28,0,0,1-6.488.607.191.191,0,0,1-.075-.034,21.83,21.83,0,0,0-3.309,5.881c-1.951,5.458-1.842,11-1.071,16.175-.061-.1-.136-.177-.211-.273a8.812,8.812,0,0,0-.682-.8,38.714,38.714,0,0,1-.382-4.85.309.309,0,0,0,0-.075,9.592,9.592,0,0,1-4.209-4.352,44.959,44.959,0,0,1-2.047-7.013,11.331,11.331,0,0,1,4.98,5.519,24.858,24.858,0,0,1,1.364,4.093c.034-.771.082-1.535.171-2.3a50.972,50.972,0,0,1-.123-8.186,31.163,31.163,0,0,1,.45-3.561,10.913,10.913,0,0,1-.628-2.285,1.6,1.6,0,0,1,.15-.791,1.146,1.146,0,0,1,1.412-.682.239.239,0,0,1,.177.225v.443a19.785,19.785,0,0,1-.682,3.049,32.173,32.173,0,0,0-.539,4.714c-.068,1.671,0,3.329.082,4.994a24.872,24.872,0,0,1,1.044-3.711,24.9,24.9,0,0,1,2.156-6.911,37.957,37.957,0,0,1,2.258-3.875,13.779,13.779,0,0,1,.682-2.77c.246-.6.594-1.044,1.064-1.016.744,0,.764.546.512,1.167h0a11.768,11.768,0,0,1-1.378,2.163,34.509,34.509,0,0,0-3.684,6.686,20.411,20.411,0,0,0-.682,2.169,24.068,24.068,0,0,1,7.286-8.685,43.879,43.879,0,0,1,6.563-3.677c1.016-.75,1.965-1.549,2.968-2.367a2.34,2.34,0,0,1,1.132-.682.682.682,0,0,1,.6.287C235.2,143.4,234.908,143.958,234.26,144.422Z",
    transform: "translate(-105.971 -137.866)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(92.262 33.512)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M194,186.286a16.168,16.168,0,0,1,5.683-1.364,15.045,15.045,0,0,1,2.981.082,14.108,14.108,0,0,1,2.927.716,11.911,11.911,0,0,1,2.661,1.48,12.756,12.756,0,0,1,2.156,2.088,14.163,14.163,0,0,1,2.729,5.185,22.977,22.977,0,0,0-3.445-4.537,13.1,13.1,0,0,0-4.537-3.056,16.836,16.836,0,0,0-5.458-1A29.909,29.909,0,0,0,194,186.286Z",
    transform: "translate(-194 -184.883)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M233,193.808a16.933,16.933,0,0,0-3.234-1.439,13.447,13.447,0,0,0-3.343-.628,7.083,7.083,0,0,0-.853,0,5.843,5.843,0,0,0-.846,0l-.86.061c-.28.055-.566.1-.853.143l-.43.061-.423.109-.86.2c-.58.143-1.132.348-1.746.484a13.906,13.906,0,0,1,1.515-1.051A10.841,10.841,0,0,1,222.77,191c.3-.1.6-.191.9-.273l.928-.157a4.9,4.9,0,0,1,.948-.082,7.337,7.337,0,0,1,.948,0,9.183,9.183,0,0,1,3.636.976,7.757,7.757,0,0,1,2.865,2.34Z",
    transform: "translate(-202.12 -186.661)",
    fill: "#222221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M271.743,184.844a51.2,51.2,0,0,1-6.14,2.995,20.7,20.7,0,0,1-3.111,1.208,2.968,2.968,0,0,1-1.781-.068,1.364,1.364,0,0,1-.819-.5.348.348,0,0,1-.089-.2,6.073,6.073,0,0,1-1.433-3.3,35,35,0,0,1-.921-7.3,6.973,6.973,0,0,1,.225-2.906c.252-.512.566-.559.962-.846.941-.682.969-1.562,1.651-2.408a1.59,1.59,0,0,1,1.467-.723c1.433.287,1.283,3.07,1.364,4.093a37.728,37.728,0,0,1,0,6.331,31.643,31.643,0,0,1-.866,5.642,36.315,36.315,0,0,1,6.9-7.743c.955-.812,2.483-2.142,3.861-1.658.559.2.5.621.86.921.764.634,1.6,0,2.395.382C279.261,180.267,272.773,184.257,271.743,184.844Z",
    transform: "translate(-121.889 -146.893)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M271.743,184.844a51.2,51.2,0,0,1-6.14,2.995,20.7,20.7,0,0,1-3.111,1.208,2.968,2.968,0,0,1-1.781-.068,1.364,1.364,0,0,1-.819-.5.348.348,0,0,1-.089-.2,6.073,6.073,0,0,1-1.433-3.3,35,35,0,0,1-.921-7.3,6.973,6.973,0,0,1,.225-2.906c.252-.512.566-.559.962-.846.941-.682.969-1.562,1.651-2.408a1.59,1.59,0,0,1,1.467-.723c1.433.287,1.283,3.07,1.364,4.093a37.728,37.728,0,0,1,0,6.331,31.643,31.643,0,0,1-.866,5.642,36.315,36.315,0,0,1,6.9-7.743c.955-.812,2.483-2.142,3.861-1.658.559.2.5.621.86.921.764.634,1.6,0,2.395.382C279.261,180.267,272.773,184.257,271.743,184.844Z",
    transform: "translate(-121.889 -146.893)",
    fill: "#cc7694",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M272.148,171.675c-2.142,4.325-4.544,8.507-6.611,12.866-.055.109-.239,0-.191-.082,1.61-3.991,3.779-7.716,5.744-11.536a25.466,25.466,0,0,0,2.36-5.942c.327-1.412.409-2.729,1.364-3.814a.355.355,0,0,1,.607.089c.573,1.364-1.057,3.35-1.917,4.653A19.738,19.738,0,0,1,272.148,171.675Z",
    transform: "translate(-124.409 -144.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M261.7,171.826c-1.549,3.977-1.9,8.3-2.4,12.484a.075.075,0,1,1-.15,0c.041-5.58,1.364-11.775,4.312-16.571.259-.43,1.978-3.063,2.674-2.183.368.471-.45,1.228-.716,1.494-.853.9-1.91,1.521-2.688,2.511h0A21.484,21.484,0,0,0,261.7,171.826Z",
    transform: "translate(-122.442 -145.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M280.7,175.467a15.008,15.008,0,0,1-2.224,5.314,31.843,31.843,0,0,1-8.616,8.637c-.075.061-.171-.075-.1-.13,3.159-2.538,6.276-5.2,8.453-8.664a19.22,19.22,0,0,0,1.474-2.831l.1-.232a.054.054,0,0,1,0-.055,15.461,15.461,0,0,0,.055-3.507,2.087,2.087,0,0,1,.225-1.453.1.1,0,0,1,.109-.048C281.138,172.751,280.831,174.771,280.7,175.467Z",
    transform: "translate(-125.806 -147.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M272.912,188.726c-4.2,2.333-9.23,3.1-13.644,4.912q-1.515.614-2.995,1.364a9.293,9.293,0,0,1-.935.443,1.174,1.174,0,0,1-.628.061.682.682,0,0,1-.252-.089,1,1,0,0,1-.5-.791,6.447,6.447,0,0,1,.089-2.047c-.061-.723-.184-1.446-.259-2.088-.1-.941-.218-1.869-.362-2.8-.321-1.978-.819-3.916-1.31-5.86a16.816,16.816,0,0,1-.682-5.035c0-.907.157-2.6.962-3.193s1.242-.048,1.528.628.266,1.364.478,1.992c.327.976.907,1.071,1.549,1.678a4.052,4.052,0,0,1,.989,3.193c-.055.921-.157,1.849-.28,2.763.273-.825.58-1.644.894-2.442a13.82,13.82,0,0,1,2.2-4.387,3.3,3.3,0,0,1,1.248-.88,6.071,6.071,0,0,0,2.729-1.6c.737-.819,1.692-2.3,2.995-2.1s1.167,1.508,1.248,2.483c.157,1.815,1.637,2.8,1.3,4.775a9.825,9.825,0,0,1-2.395,4.23,28.007,28.007,0,0,1-2.51,2.729,15.6,15.6,0,0,1,3.854-1.671,3.52,3.52,0,0,1,1.822-.171c.88.232.928.791,2.047.682.832-.1,2.654-.682,3.1.471S273.737,188.262,272.912,188.726Z",
    transform: "translate(-119.988 -147.411)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M272.912,188.726c-4.2,2.333-9.23,3.1-13.644,4.912q-1.515.614-2.995,1.364a9.293,9.293,0,0,1-.935.443,1.174,1.174,0,0,1-.628.061.682.682,0,0,1-.252-.089,1,1,0,0,1-.5-.791,6.447,6.447,0,0,1,.089-2.047c-.061-.723-.184-1.446-.259-2.088-.1-.941-.218-1.869-.362-2.8-.321-1.978-.819-3.916-1.31-5.86a16.816,16.816,0,0,1-.682-5.035c0-.907.157-2.6.962-3.193s1.242-.048,1.528.628.266,1.364.478,1.992c.327.976.907,1.071,1.549,1.678a4.052,4.052,0,0,1,.989,3.193c-.055.921-.157,1.849-.28,2.763.273-.825.58-1.644.894-2.442a13.82,13.82,0,0,1,2.2-4.387,3.3,3.3,0,0,1,1.248-.88,6.071,6.071,0,0,0,2.729-1.6c.737-.819,1.692-2.3,2.995-2.1s1.167,1.508,1.248,2.483c.157,1.815,1.637,2.8,1.3,4.775a9.825,9.825,0,0,1-2.395,4.23,28.007,28.007,0,0,1-2.51,2.729,15.6,15.6,0,0,1,3.854-1.671,3.52,3.52,0,0,1,1.822-.171c.88.232.928.791,2.047.682.832-.1,2.654-.682,3.1.471S273.737,188.262,272.912,188.726Z",
    transform: "translate(-119.988 -147.411)",
    fill: "#cc7694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M254.56,186.09v.048C254.6,186.131,254.587,186.083,254.56,186.09Z",
    transform: "translate(-120.984 -151.754)",
    fill: "#f1d1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M270.614,191.7c-4.148,2.647-11.352,2.135-14.135,6.638v.218a1.173,1.173,0,0,1-.628.061c-.628-1.569-.327-3.322-.266-5a30.016,30.016,0,0,0-.525-7.573c0-.068.082-.089.109,0a21.443,21.443,0,0,1,.88,5.915c.048,2.047-.5,4.5.089,6.488l.041-.2a16.54,16.54,0,0,1,1.869-6.658c1.214-2.64,2.729-5.1,4.2-7.62.055-.1.2,0,.143.1-1.255,2.476-2.558,4.946-3.732,7.463a27.232,27.232,0,0,0-1.835,4.775c2.292-5.349,8.534-8.412,10.479-13.965a.1.1,0,0,1,.2.068c-1.965,5.9-8.282,9.176-10.649,14.8a6.467,6.467,0,0,1,1.31-1.2,14.463,14.463,0,0,1,3.411-2.5c2.047-1.071,4.284-1.6,6.263-2.818.075-.041.15.075.089.13-1.521,1.3-3.513,1.794-5.308,2.606a16.23,16.23,0,0,0-3.049,1.787,17.743,17.743,0,0,1,1.781-.723c3.063-1.085,6.235-1.59,9.2-2.974a.1.1,0,0,1,.075.184Z",
    transform: "translate(-121.143 -150.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M254.109,181.363a3.834,3.834,0,0,0,.116,1.883.048.048,0,0,0,.089,0,8.247,8.247,0,0,1,0-1.835C254.286,181.3,254.136,181.26,254.109,181.363Z",
    transform: "translate(-120.819 -150.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M273.45,179.468c-.075.341-.068.682-.13,1.051a.1.1,0,0,0,.184.041,1.78,1.78,0,0,0,.15-1.078C273.627,179.393,273.47,179.359,273.45,179.468Z",
    transform: "translate(-126.945 -149.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M279.985,194.193a3.512,3.512,0,0,0-.5.321.082.082,0,0,0,.048.136.907.907,0,0,0,.587-.273C280.2,194.295,280.1,194.124,279.985,194.193Z",
    transform: "translate(-128.896 -154.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M253.951,200.814c.143,1.6.512,3.309-.28,4.885-.068.136.061.259.164.157.785-.846,5.956-2.872,5.724-3.745-.143-.532-1.576.13-1.774-.607a3.411,3.411,0,0,1,.266-1.269c.109-.423.2-.86.273-1.289s.055-.907-.293-1.057-.853.341-1.126.682-.437.594-.648.894-.559.948-.86.409-.348-1.044-.75-1.4C253.733,197.669,253.889,200.336,253.951,200.814Z",
    transform: "translate(-120.695 -155.495)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M250.684,223.952a13.385,13.385,0,0,0-.682-1.364,9.474,9.474,0,0,0-.682-1.064c0-.293.048-.594.075-.887.15-1.651.362-3.3.648-4.926.075-.457.164-.914.252-1.364.2-1.057.437-2.108.682-3.159a18.421,18.421,0,0,1,1.624-4.441,11.467,11.467,0,0,1,.873-1.364l.28-.355.307-.368.259-.287.041-.041a.118.118,0,0,1,.177.157l-.246.314a2.726,2.726,0,0,0-.157.232c-.089.123-.177.259-.266.389a.56.56,0,0,0-.1.177,11.269,11.269,0,0,0-.955,2.006,35.728,35.728,0,0,0-1.5,7.927q-.246,1.917-.4,3.827a1.651,1.651,0,0,0,0,.321C250.821,221.08,250.732,222.512,250.684,223.952Z",
    transform: "translate(-119.318 -157.539)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M248.195,214.476s.191-5.533-.86-8.337-4.393-6.42-4.393-6.42a14.831,14.831,0,0,0,5.253,14.756Z",
    transform: "translate(-117.184 -156.086)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M251.52,221.505s2.013-5.164,4.093-7.32,6.563-4.175,6.563-4.175a14.831,14.831,0,0,1-10.656,11.5Z",
    transform: "translate(-120.018 -159.356)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(112.237 57.38)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M223.28,220.361a18.2,18.2,0,0,1,6.931-.287,17.635,17.635,0,0,1,6.631,2.367,15.117,15.117,0,0,1,2.79,2.231,14.135,14.135,0,0,1,2.115,2.865,14.449,14.449,0,0,1,1.849,6.692,19.915,19.915,0,0,0-2.674-6.188,15.008,15.008,0,0,0-4.728-4.544c-.471-.293-.955-.553-1.446-.819a13.253,13.253,0,0,0-1.521-.682,21.953,21.953,0,0,0-3.193-1,27.82,27.82,0,0,0-6.754-.641Z",
    transform: "translate(-223.28 -219.869)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M265.495,229.577a25.733,25.733,0,0,0-3.7-.614,15.254,15.254,0,0,0-3.623.136,12.965,12.965,0,0,0-1.753.389,13.606,13.606,0,0,0-1.678.682,20.828,20.828,0,0,0-3.206,1.944,9,9,0,0,1,2.729-2.783,9.354,9.354,0,0,1,1.774-.935,10.655,10.655,0,0,1,1.937-.5,10.458,10.458,0,0,1,3.964.143,9.551,9.551,0,0,1,3.561,1.542Z",
    transform: "translate(-232.258 -222.379)",
    fill: "#222221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M105.306,169.323c2.606,2.128,5.928,2.981,9.08,3.93.887.266,1.753.546,2.62.853a3.623,3.623,0,0,0,1.91.3c1.132-.232,1.242-1.248,1.255-2.231a6.179,6.179,0,0,0,0-.941v-.211a.13.13,0,0,0-.034-.116c0-.382-.061-.757-.089-1.112-.164-2.047-.348-4.093-.525-6.1a28.372,28.372,0,0,0-.621-4.912c-.15-.566-.314-1.324-.887-1.617a9.838,9.838,0,0,0-1.023-.293,2.156,2.156,0,0,1-.771-.559c-.559-.587-1.555-2.36-2.6-1.794a2.113,2.113,0,0,0-.8,1.508,5.41,5.41,0,0,1-1.235,1.8,3.522,3.522,0,0,0-.157,3.466,18.638,18.638,0,0,0,2.374,4.093c.948,1.323,1.985,2.579,2.947,3.9a25.664,25.664,0,0,1,1.487,2.251c.225.382.43.764.621,1.16a3.732,3.732,0,0,1,.348.853,42.3,42.3,0,0,0-3.752-4.093,44.146,44.146,0,0,0-4.134-4.168,6.822,6.822,0,0,0-4.045-1.514,7.252,7.252,0,0,1-2.449-.293,12.382,12.382,0,0,0-2.169-.682c-1.644-.232-.825,1.706-.471,2.49A10.915,10.915,0,0,0,105.306,169.323Z",
    transform: "translate(-72.396 -141.686)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M105.306,169.323c2.606,2.128,5.928,2.981,9.08,3.93.887.266,1.753.546,2.62.853a3.623,3.623,0,0,0,1.91.3c1.132-.232,1.242-1.248,1.255-2.231a6.179,6.179,0,0,0,0-.941v-.211a.13.13,0,0,0-.034-.116c0-.382-.061-.757-.089-1.112-.164-2.047-.348-4.093-.525-6.1a28.372,28.372,0,0,0-.621-4.912c-.15-.566-.314-1.324-.887-1.617a9.838,9.838,0,0,0-1.023-.293,2.156,2.156,0,0,1-.771-.559c-.559-.587-1.555-2.36-2.6-1.794a2.113,2.113,0,0,0-.8,1.508,5.41,5.41,0,0,1-1.235,1.8,3.522,3.522,0,0,0-.157,3.466,18.638,18.638,0,0,0,2.374,4.093c.948,1.323,1.985,2.579,2.947,3.9a25.664,25.664,0,0,1,1.487,2.251c.225.382.43.764.621,1.16a3.732,3.732,0,0,1,.348.853,42.3,42.3,0,0,0-3.752-4.093,44.146,44.146,0,0,0-4.134-4.168,6.822,6.822,0,0,0-4.045-1.514,7.252,7.252,0,0,1-2.449-.293,12.382,12.382,0,0,0-2.169-.682c-1.644-.232-.825,1.706-.471,2.49A10.915,10.915,0,0,0,105.306,169.323Z",
    transform: "translate(-72.396 -141.686)",
    fill: "#cc7694",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M122.856,170.043a23.01,23.01,0,0,0,0-6.74,36.45,36.45,0,0,0-4.468-12.2,9.878,9.878,0,0,0-1.61-2.3c-.287-.273-.928-.573-.907.1a2.5,2.5,0,0,0,1.037,1.569,12.615,12.615,0,0,1,1.658,1.467c.362.682.682,1.364,1.037,2.047a39.746,39.746,0,0,1,2.122,5.328,24.682,24.682,0,0,1,1.092,10.738Z",
    transform: "translate(-76.909 -139.808)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M116.694,175.557a22.916,22.916,0,0,1-6.454-1.958,36.293,36.293,0,0,1-10.383-7.8,9.326,9.326,0,0,1-1.733-2.2c-.184-.348-.287-1.051.348-.839A2.415,2.415,0,0,1,99.68,164.2a12.225,12.225,0,0,0,.921,2.047c.539.539,1.085,1.064,1.651,1.583a39.614,39.614,0,0,0,4.489,3.568,24.655,24.655,0,0,0,9.96,4.148S116.728,175.564,116.694,175.557Z",
    transform: "translate(-71.225 -144.325)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M107.594,157.186q1.76,2.347,3.643,4.591a111.533,111.533,0,0,0,7.961,8.493s.055,0,0-.041c-2.729-2.729-5.314-5.642-7.784-8.6q-1.856-2.217-3.588-4.516c-.232-.321-.471-.634-.682-.962-.389-1.016-.682-1.958-1.146-2.947-.232-.464-.785-1.542-1.31-1.16C104.026,152.547,106.448,155.638,107.594,157.186Z",
    transform: "translate(-73.32 -140.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M101.2,169.506a11.6,11.6,0,0,0,2.763,2.954,21.64,21.64,0,0,0,7.818,3.718,19.293,19.293,0,0,0,8.309.607h.1a.055.055,0,0,0,.068,0,.778.778,0,0,0,.211-.061s.266-.048.2-.075a4.955,4.955,0,0,1,.375-.457,12.28,12.28,0,0,0,1.323-1.781,8.269,8.269,0,0,0,.8-2.647c.307-2.108,0-4.257.259-6.372.2-1.842.894-3.6.832-5.458,0-.409-.068-1.071-.641-.962-.73.143-.832,1.153-1.31,1.576-.034.109-.123.143-.252.1-.164.082-.266.034-.314-.15a1.739,1.739,0,0,1-.164-.341,7.768,7.768,0,0,1-.28-.757c-.15-.45-.266-.914-.389-1.364a5.594,5.594,0,0,0-.914-2.319.682.682,0,0,0-1.187.15,5.458,5.458,0,0,0-.28,2.354c0,.553-.116,1.364-.866,1.194-.307-.061-.587-.246-.894-.307a1.187,1.187,0,0,0-1.317.771,4.614,4.614,0,0,0,.116,2.558,25.554,25.554,0,0,0,.866,3c.682,1.869,2.183,5.4,2.961,7.225.423,1-4.325-9.346-6.14-11.434a2.476,2.476,0,0,0-1.644-.682c-.4,0-.764.157-1.16.15a3.07,3.07,0,0,1-1.16-.341c-.982-.437-2.661-.955-2.933.566a9.919,9.919,0,0,0,.2,2.047,4.987,4.987,0,0,1-.641,1.842c-.566,1.453.791,2.729,1.74,3.7a28.583,28.583,0,0,0,3.834,3.261c.846.614,4.093,2.729,4.973,3.275-1.126-.573-4.612-2.729-5.71-3.37-.723-.416-1.433-.853-2.128-1.3s-1.248-.9-1.91-1.262A3.179,3.179,0,0,0,105,168.8a13.311,13.311,0,0,1-2.395-.443c-.423-.068-1.208-.334-1.515.1C100.828,168.722,100.985,169.2,101.2,169.506Z",
    transform: "translate(-72.168 -142.013)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M101.2,169.506a11.6,11.6,0,0,0,2.763,2.954,21.64,21.64,0,0,0,7.818,3.718,19.293,19.293,0,0,0,8.309.607h.1a.055.055,0,0,0,.068,0,.778.778,0,0,0,.211-.061s.266-.048.2-.075a4.955,4.955,0,0,1,.375-.457,12.28,12.28,0,0,0,1.323-1.781,8.269,8.269,0,0,0,.8-2.647c.307-2.108,0-4.257.259-6.372.2-1.842.894-3.6.832-5.458,0-.409-.068-1.071-.641-.962-.73.143-.832,1.153-1.31,1.576-.034.109-.123.143-.252.1-.164.082-.266.034-.314-.15a1.739,1.739,0,0,1-.164-.341,7.768,7.768,0,0,1-.28-.757c-.15-.45-.266-.914-.389-1.364a5.594,5.594,0,0,0-.914-2.319.682.682,0,0,0-1.187.15,5.458,5.458,0,0,0-.28,2.354c0,.553-.116,1.364-.866,1.194-.307-.061-.587-.246-.894-.307a1.187,1.187,0,0,0-1.317.771,4.614,4.614,0,0,0,.116,2.558,25.554,25.554,0,0,0,.866,3c.682,1.869,2.183,5.4,2.961,7.225.423,1-4.325-9.346-6.14-11.434a2.476,2.476,0,0,0-1.644-.682c-.4,0-.764.157-1.16.15a3.07,3.07,0,0,1-1.16-.341c-.982-.437-2.661-.955-2.933.566a9.919,9.919,0,0,0,.2,2.047,4.987,4.987,0,0,1-.641,1.842c-.566,1.453.791,2.729,1.74,3.7a28.583,28.583,0,0,0,3.834,3.261c.846.614,4.093,2.729,4.973,3.275-1.126-.573-4.612-2.729-5.71-3.37-.723-.416-1.433-.853-2.128-1.3s-1.248-.9-1.91-1.262A3.179,3.179,0,0,0,105,168.8a13.311,13.311,0,0,1-2.395-.443c-.423-.068-1.208-.334-1.515.1C100.828,168.722,100.985,169.2,101.2,169.506Z",
    transform: "translate(-72.168 -142.013)",
    fill: "#cc7694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M109.13,176.71a27.186,27.186,0,0,0,13.337,3.977.055.055,0,0,0,.055,0h.273a.055.055,0,0,0,.068,0,.778.778,0,0,0,.211-.061s.266-.048.2-.075a4.955,4.955,0,0,1,.375-.457,10.915,10.915,0,0,0,1.323-5.273c-.061-1.18-.321-2.354-.43-3.541a23.877,23.877,0,0,1-.068-3.629h0a30.411,30.411,0,0,0-.082,3.527c.048,1.126.239,2.238.321,3.356.157,2.094-.634,3.841-1.364,5.69a16.182,16.182,0,0,0,.341-5.035,40.425,40.425,0,0,0-1.242-6.017c0-.055-.089-.041-.075,0,.375,1.992.9,3.984,1.112,6a16.694,16.694,0,0,1-.287,5.178c-1.637-1.985-2.947-4.2-4.373-6.331a50.906,50.906,0,0,0-4.571-5.874s-.075,0-.048.048a54.167,54.167,0,0,1,4.646,6.269,46.92,46.92,0,0,0,4.093,5.847,28.712,28.712,0,0,1-4.687-3.9c-1.46-1.6-2.865-3.261-4.257-4.926h0c1.364,1.76,2.729,3.554,4.25,5.212a22.936,22.936,0,0,0,4.844,3.854c-4.509-.164-8.664-2.62-12.457-5,2.961,1.89,6,3.841,9.346,4.687a28.557,28.557,0,0,1-4.544-.88,27.492,27.492,0,0,1-6.215-2.729Z",
    transform: "translate(-74.767 -145.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M128.34,162.5c0-.061.1-.061.1,0a34.971,34.971,0,0,0,0,3.588.068.068,0,0,1-.13,0,10.506,10.506,0,0,1,.034-3.588Z",
    transform: "translate(-80.817 -144.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M113.071,169.6a6.556,6.556,0,0,1,.88.8c0,.041,0,.116-.068.082a6.707,6.707,0,0,1-.866-.839C113,169.618,113,169.57,113.071,169.6Z",
    transform: "translate(-76 -146.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M109.215,178l.478.327c.068.041,0,.143-.055.1l-.457-.355C109.14,178.055,109.175,178,109.215,178Z",
    transform: "translate(-74.778 -149.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M125.563,185.578c1.426.525,3.09.873,3.936,2.272a.123.123,0,0,0,.225-.089c-.232-1.092,1.173-6.822.293-6.945-.532-.082-.832,1.542-1.576,1.426-.314-.048-.682-.559-.907-.771a9.911,9.911,0,0,0-.914-.8c-.3-.225-.737-.43-1.071-.157s-.225.941-.1,1.364a7.957,7.957,0,0,0,.362.976c.123.293.464.921-.171.982a4.864,4.864,0,0,0-1.63.136C122.787,184.48,125.133,185.4,125.563,185.578Z",
    transform: "translate(-79.384 -149.939)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M142.378,205.7h-.055l-.976-.143h-.539c-.252-.682-.532-1.283-.832-1.9-.157-.341-.327-.682-.5-1.023q-.86-1.678-1.856-3.247c-2.142-3.411-4.407-6.672-6.29-10.172q-.894-1.658-1.651-3.411c-.041-.082-.068-.164-.1-.239-.136-.334-.28-.682-.409-1.023,0-.082.1-.136.136-.055.1.252.211.5.334.75,0,.068.061.136.089.2h0s.055.123.089.184a28.741,28.741,0,0,0,1.63,2.94c1.624,2.62,3.568,5.069,5.41,7.573.136.184.273.368.4.559a45.818,45.818,0,0,1,3.268,5.021,30.741,30.741,0,0,1,1.849,3.991Z",
    transform: "translate(-81.136 -151.23)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M139.04,209.793s-4.093-3.752-6.89-4.775-7.729-.853-7.729-.853A14.838,14.838,0,0,0,139.04,209.793Z",
    transform: "translate(-79.626 -157.495)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M140.4,195.673s-.955-5.458-.3-8.371,3.452-6.972,3.452-6.972A14.818,14.818,0,0,1,140.4,195.673Z",
    transform: "translate(-84.537 -149.924)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M145.791,152.252c.873-.211,1.453,1.624,1.61,2.19a6.6,6.6,0,0,1-.518,4.475.936.936,0,0,1-.136.3v.041h0l-.089.089a.3.3,0,0,1-.3.061c-1.126-.491-1.071-2.1-1.057-3.1C145.272,155.7,144.761,152.5,145.791,152.252Z",
    transform: "translate(-86.214 -140.996)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M145.791,152.252c.873-.211,1.453,1.624,1.61,2.19a6.6,6.6,0,0,1-.518,4.475.936.936,0,0,1-.136.3v.041h0l-.089.089a.3.3,0,0,1-.3.061c-1.126-.491-1.071-2.1-1.057-3.1C145.272,155.7,144.761,152.5,145.791,152.252Z",
    transform: "translate(-86.214 -140.996)",
    fill: "#cc7694",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M137.481,166.2c-.532,1.494.464,2.94,1.364,4,.348.409,1.405,1.569,1.856.976a.143.143,0,0,0,.164-.1,2.729,2.729,0,0,0-.2-1.781c-.348-.941-.682-1.917-1.126-2.831S137.958,164.888,137.481,166.2Z",
    transform: "translate(-83.729 -145.199)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M137.481,166.2c-.532,1.494.464,2.94,1.364,4,.348.409,1.405,1.569,1.856.976a.143.143,0,0,0,.164-.1,2.729,2.729,0,0,0-.2-1.781c-.348-.941-.682-1.917-1.126-2.831S137.958,164.888,137.481,166.2Z",
    transform: "translate(-83.729 -145.199)",
    fill: "#cc7694",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M156.322,180.2a10.151,10.151,0,0,1-3.623,5.574,28.926,28.926,0,0,1-.559,6.863c-.273.2-.525.416-.771.634.123-.587.225-1.167.314-1.76a.211.211,0,0,0,0-.055c-3.691-1.944-5.342-5.7-6.727-9.5h0a11.9,11.9,0,0,1,6.9,8.541,32.022,32.022,0,0,0-.225-8.732c-1.555-4.544-5.458-7.784-9.237-10.772a5.7,5.7,0,0,1-1.7-1.753h0a.73.73,0,0,1-.068-.15c-.15-.362-.334-1.146.15-1.364s.873.389,1.112.723a1.24,1.24,0,0,1,.1.157c.682.941,1.289,1.931,1.89,2.913a36.422,36.422,0,0,1,4.032,3.5,18.358,18.358,0,0,1,3.254,4.455c-.061-.246-.109-.491-.171-.744A44.384,44.384,0,0,0,146.9,168.7a30.7,30.7,0,0,1-2.047-4.23,9.4,9.4,0,0,1-.648-3.227,2.86,2.86,0,0,1,.136-.785c.184-.566.682-.825,1.071-.259a1.712,1.712,0,0,1,.239.764h0a13.7,13.7,0,0,1,0,1.5c.061,1,.109,2.013.143,3.022.327.682.682,1.3,1.051,1.944a45.831,45.831,0,0,1,4.775,10.745,33.256,33.256,0,0,1,.962,4.966,24.56,24.56,0,0,1,.757-3.909A25.057,25.057,0,0,1,156.124,174a12.055,12.055,0,0,1,.2,6.194Z",
    transform: "translate(-84.724 -143.427)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(39.732 46.684)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M126.3,226.083a12.191,12.191,0,0,1,3.6-6.576,14.947,14.947,0,0,1,4.775-3.152l.887-.368.941-.28a10.868,10.868,0,0,1,3.9-.348l.976.136c.321.048.634.157.948.232l.471.13.457.171c.293.123.607.225.894.375a14.361,14.361,0,0,1,5.69,4.912,18.685,18.685,0,0,0-6.072-4.025,10.915,10.915,0,0,0-6.931-.389,16.946,16.946,0,0,0-6.317,3.316A14.824,14.824,0,0,0,126.3,226.083Z",
    transform: "translate(-119.955 -207.725)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M169.234,205.35a25.24,25.24,0,0,0-5.3-.211,16.9,16.9,0,0,0-5.035,1.092,14.327,14.327,0,0,0-4.339,2.729,22.308,22.308,0,0,0-3.37,4.093,12.914,12.914,0,0,1,2.681-4.775,12.628,12.628,0,0,1,2.094-1.856,14.15,14.15,0,0,1,2.476-1.324,14.545,14.545,0,0,1,10.793.273Z",
    transform: "translate(-127.865 -204.191)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M117,217.508a6.044,6.044,0,0,1,2.688-1.105,6.822,6.822,0,0,1,2.981.143,6.3,6.3,0,0,1,2.626,1.426,6.03,6.03,0,0,1,.989,1.1,7.715,7.715,0,0,1,.682,1.276c-.416-.273-.75-.594-1.132-.853a12.817,12.817,0,0,0-1.126-.744,9.223,9.223,0,0,0-2.381-1.01,10.75,10.75,0,0,0-2.586-.375A20.181,20.181,0,0,0,117,217.508Z",
    transform: "translate(-117 -208.04)",
    fill: "#222221"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(81.749 76.584)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M178.59,250.107a13.644,13.644,0,0,1,4.632-1.787,15.773,15.773,0,0,1,5.035-.177,18.175,18.175,0,0,1,2.476.525,15.655,15.655,0,0,1,2.333.989,13.331,13.331,0,0,1,3.9,3.077,28.148,28.148,0,0,0-4.3-2.2,20.181,20.181,0,0,0-2.251-.737,19.149,19.149,0,0,0-2.313-.43,21.955,21.955,0,0,0-4.735-.1A29.338,29.338,0,0,0,178.59,250.107Z",
    transform: "translate(-178.59 -248.019)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M197.06,260.225A14.722,14.722,0,0,1,201.9,253.5a16.284,16.284,0,0,1,7.743-3.322,15.1,15.1,0,0,1,8.371,1,13.167,13.167,0,0,1,3.554,2.292,11.912,11.912,0,0,1,2.6,3.247,14.729,14.729,0,0,0-2.981-2.777,14.51,14.51,0,0,0-3.534-1.869,14.709,14.709,0,0,0-3.868-.819,6.82,6.82,0,0,0-.989-.048H211.8c-.682.075-1.323.1-1.978.211l-.982.171a2.084,2.084,0,0,0-.491.1l-.478.13-.955.266c-.314.109-.621.239-.935.348a16.559,16.559,0,0,0-1.815.812c-.566.348-1.167.648-1.7,1.044a18.017,18.017,0,0,0-5.41,5.942Z",
    transform: "translate(-184.46 -248.64)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M224.164,256.7a14.729,14.729,0,0,0-2.981-2.777,14.259,14.259,0,0,0-3.534-1.862,14.457,14.457,0,0,0-3.861-.826,7.008,7.008,0,0,0-1-.048H211.8c-.682.075-1.323.089-1.978.2l-.982.171a2.084,2.084,0,0,0-.491.1l-.478.136-.962.266c-.307.1-.614.232-.928.348a11.6,11.6,0,0,0-1.555.682l-.259.123-.621.355a12.559,12.559,0,0,0-1.078.682,18.018,18.018,0,0,0-5.41,5.956,14.654,14.654,0,0,1,4.837-6.72,12.361,12.361,0,0,1,1.242-.914c.273-.171.553-.341.832-.5a17.355,17.355,0,0,1,5.669-1.91,15.009,15.009,0,0,1,8.371,1,13.187,13.187,0,0,1,3.547,2.292A11.836,11.836,0,0,1,224.164,256.7Z",
    transform: "translate(-184.46 -248.635)",
    fill: "#222221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M180.876,218.855a44.237,44.237,0,0,0,4.775,3.479,18.375,18.375,0,0,0,2.463,1.494,2.552,2.552,0,0,0,1.535.211,1.146,1.146,0,0,0,.771-.3.327.327,0,0,0,.1-.15,5.3,5.3,0,0,0,1.726-2.6,30.971,30.971,0,0,0,1.883-6.085,5.822,5.822,0,0,0,.246-2.51c-.143-.471-.4-.559-.682-.866-.682-.716-.594-1.474-1.044-2.3a1.364,1.364,0,0,0-1.139-.839c-1.262,0-1.555,2.429-1.781,3.281a31.96,31.96,0,0,0-.955,5.389,27.7,27.7,0,0,0-.109,4.939,31.341,31.341,0,0,0-4.735-7.634c-.682-.832-1.787-2.2-3.036-1.992-.5.082-.518.45-.873.682-.75.423-1.364-.259-2.1-.034C175.159,213.82,180.084,218.2,180.876,218.855Z",
    transform: "translate(-96.364 -158.841)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M180.876,218.855a44.237,44.237,0,0,0,4.775,3.479,18.375,18.375,0,0,0,2.463,1.494,2.552,2.552,0,0,0,1.535.211,1.146,1.146,0,0,0,.771-.3.327.327,0,0,0,.1-.15,5.3,5.3,0,0,0,1.726-2.6,30.971,30.971,0,0,0,1.883-6.085,5.822,5.822,0,0,0,.246-2.51c-.143-.471-.4-.559-.682-.866-.682-.716-.594-1.474-1.044-2.3a1.364,1.364,0,0,0-1.139-.839c-1.262,0-1.555,2.429-1.781,3.281a31.96,31.96,0,0,0-.955,5.389,27.7,27.7,0,0,0-.109,4.939,31.341,31.341,0,0,0-4.735-7.634c-.682-.832-1.787-2.2-3.036-1.992-.5.082-.518.45-.873.682-.75.423-1.364-.259-2.1-.034C175.159,213.82,180.084,218.2,180.876,218.855Z",
    transform: "translate(-96.364 -158.841)",
    fill: "#cc7694",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M186.829,207.189c1.173,4,2.586,7.934,3.691,11.959.034.1.2.055.177-.041-.771-3.65-2.047-7.15-3.159-10.7a22.041,22.041,0,0,1-1.112-5.417c-.061-1.255.061-2.381-.614-3.459a.3.3,0,0,0-.525,0c-.682,1.105.389,3.015.935,4.25A16.719,16.719,0,0,0,186.829,207.189Z",
    transform: "translate(-98.899 -155.976)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M196.992,209.136c.723,3.616.368,7.347.164,11a.068.068,0,0,0,.136,0,28.777,28.777,0,0,0-1.18-14.777c-.157-.4-1.228-2.906-1.951-2.265-.382.348.2,1.119.382,1.364A30.256,30.256,0,0,1,196.46,207h0A19.1,19.1,0,0,1,196.992,209.136Z",
    transform: "translate(-101.749 -157.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M178.53,209.066a13.023,13.023,0,0,0,1.1,4.864,27.6,27.6,0,0,0,6.044,8.664c.055.055.157-.041.1-.1a31.44,31.44,0,0,1-5.894-8.657,15.507,15.507,0,0,1-.825-2.633.969.969,0,0,0-.055-.211c-.02-.075,0,0,0-.048a13.459,13.459,0,0,1,.484-2.988c.116-.457.28-1.248-.061-1.364C178.571,206.686,178.537,208.459,178.53,209.066Z",
    transform: "translate(-96.822 -158.269)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M177.346,221.224c3.234,2.62,7.4,4.039,10.915,6.242.8.5,1.576,1.044,2.347,1.6a7.5,7.5,0,0,0,.73.525.982.982,0,0,0,.525.143.546.546,0,0,0,.232-.034.894.894,0,0,0,.546-.6,5.376,5.376,0,0,0,.232-1.74c.164-.607.375-1.208.532-1.74q.341-1.18.737-2.333c.566-1.644,1.283-3.213,2-4.775a14.763,14.763,0,0,0,1.364-4.189c.1-.778.252-2.238-.341-2.865s-1.057-.225-1.364.3-.43,1.119-.682,1.63c-.423.785-.928.778-1.569,1.2a3.513,3.513,0,0,0-1.323,2.572c-.1.791-.143,1.6-.177,2.395-.109-.75-.246-1.487-.4-2.217a12.281,12.281,0,0,0-1.214-4.093,2.893,2.893,0,0,0-.928-.935,5.253,5.253,0,0,1-2.047-1.774c-.512-.812-1.1-2.217-2.238-2.244S184,209.4,183.787,210.22c-.409,1.521-1.822,2.135-1.828,3.868a8.61,8.61,0,0,0,1.4,3.964,24.33,24.33,0,0,0,1.733,2.729,13.644,13.644,0,0,0-3.036-2.006,3.015,3.015,0,0,0-1.528-.423c-.785.068-.914.539-1.842.259-.682-.2-2.156-1-2.729-.068S176.712,220.706,177.346,221.224Z",
    transform: "translate(-95.959 -158.809)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M177.346,221.224c3.234,2.62,7.4,4.039,10.915,6.242.8.5,1.576,1.044,2.347,1.6a7.5,7.5,0,0,0,.73.525.982.982,0,0,0,.525.143.546.546,0,0,0,.232-.034.894.894,0,0,0,.546-.6,5.376,5.376,0,0,0,.232-1.74c.164-.607.375-1.208.532-1.74q.341-1.18.737-2.333c.566-1.644,1.283-3.213,2-4.775a14.763,14.763,0,0,0,1.364-4.189c.1-.778.252-2.238-.341-2.865s-1.057-.225-1.364.3-.43,1.119-.682,1.63c-.423.785-.928.778-1.569,1.2a3.513,3.513,0,0,0-1.323,2.572c-.1.791-.143,1.6-.177,2.395-.109-.75-.246-1.487-.4-2.217a12.281,12.281,0,0,0-1.214-4.093,2.893,2.893,0,0,0-.928-.935,5.253,5.253,0,0,1-2.047-1.774c-.512-.812-1.1-2.217-2.238-2.244S184,209.4,183.787,210.22c-.409,1.521-1.822,2.135-1.828,3.868a8.61,8.61,0,0,0,1.4,3.964,24.33,24.33,0,0,0,1.733,2.729,13.644,13.644,0,0,0-3.036-2.006,3.015,3.015,0,0,0-1.528-.423c-.785.068-.914.539-1.842.259-.682-.2-2.156-1-2.729-.068S176.712,220.706,177.346,221.224Z",
    transform: "translate(-95.959 -158.809)",
    fill: "#cc7694",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M203.774,222.809v.041C203.774,222.843,203.747,222.8,203.774,222.809Z",
    transform: "translate(-104.841 -163.423)",
    fill: "#f1d1c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M182.388,224.3c3.131,2.858,9.353,3.541,11.045,7.791v.191a.982.982,0,0,0,.525.143c.771-1.242.778-2.777.982-4.216a26.013,26.013,0,0,1,1.59-6.379c0-.055-.055-.089-.089-.034a18.352,18.352,0,0,0-1.644,4.912c-.348,1.712-.246,3.9-1.051,5.512a1.6,1.6,0,0,1,0-.177,14.173,14.173,0,0,0-.587-5.956c-.634-2.435-1.583-4.775-2.429-7.129,0-.1-.171,0-.143.068.682,2.3,1.439,4.6,2.047,6.918a23.483,23.483,0,0,1,.846,4.339c-1.187-4.878-6.017-8.432-6.822-13.453a.1.1,0,0,0-.184,0c.791,5.328,5.676,9.073,6.822,14.224a5.336,5.336,0,0,0-.935-1.221,12.4,12.4,0,0,0-2.531-2.647c-1.583-1.228-3.411-2.006-4.919-3.343-.055-.055-.136,0-.089.1,1.1,1.364,2.729,2.047,4.127,3.015a14.136,14.136,0,0,1,2.333,1.985,14.18,14.18,0,0,0-1.412-.88c-2.442-1.364-5.069-2.292-7.388-3.923a.095.095,0,1,0-.1.164Z",
    transform: "translate(-98.033 -161.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M204.626,218.841a3.411,3.411,0,0,1-.382,1.59c0,.041-.089,0-.075,0a6.972,6.972,0,0,0,.3-1.555C204.483,218.759,204.62,218.745,204.626,218.841Z",
    transform: "translate(-104.969 -162.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M188.5,214.3c0,.3-.048.607-.048.914,0,.1-.143.089-.164,0a1.583,1.583,0,0,1,.034-.941C188.352,214.208,188.489,214.2,188.5,214.3Z",
    transform: "translate(-99.904 -160.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M180.6,225.84a3.817,3.817,0,0,1,.389.348.068.068,0,0,1-.061.109.757.757,0,0,1-.457-.321C180.4,225.894,180.518,225.764,180.6,225.84Z",
    transform: "translate(-97.432 -164.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M199.434,235.017c-.362,1.364-.935,2.729-.5,4.2.041.123-.089.211-.157.1-.546-.839-4.653-3.343-4.318-4.052.2-.43,1.323.355,1.6-.252a2.968,2.968,0,0,0,0-1.119c0-.375-.048-.757-.041-1.132s.089-.785.409-.86.682.416.86.75.28.566.416.853.334.9.682.484.457-.839.853-1.078C200.1,232.37,199.543,234.608,199.434,235.017Z",
    transform: "translate(-101.879 -166.312)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M204.587,247.473c-.28.157-.559.327-.832.5l-.041-.1c-.907-2.047-2-4.052-2.92-6.14A25.064,25.064,0,0,1,199,235.493h0c.682,3.814,3.172,7.313,4.926,10.7A12.644,12.644,0,0,1,204.587,247.473Z",
    transform: "translate(-103.327 -167.45)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M205.2,244.353s-.546-5.853.4-8.869,4.257-7.074,4.257-7.074A15.745,15.745,0,0,1,205.2,244.353Z",
    transform: "translate(-105.247 -165.203)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-75",
    transform: "translate(166.505 70.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M328.528,370.462c1.255.416,36.969.314,38.326-.553.512-.321.8-5.526.976-11.823q.055-2.047.089-4.189c0-1.692.048-3.411.055-5.062.048-7.457-.055-14.026-.055-14.026H344.662V353.9l.123,4.189s-13.644,6.14-15.049,7.266S327.314,370.053,328.528,370.462Z",
    transform: "translate(-262.333 -165.564)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M367.86,366.92c0,.464,0,.921-.034,1.364-.171,6.3-.464,11.5-.976,11.823-1.364.866-37.071.969-38.326.553s-.15-4,1.228-5.11a96.028,96.028,0,0,1,8.794-4.4c-1.153,1.037-2.729,2.613-2.292,3.172,1.146,1.515,24.273-1.658,30.542-6.7a5.835,5.835,0,0,1,1.064-.7Z",
    transform: "translate(-262.329 -175.784)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M382.346,189.58s-6.283,62.149-6.426,62.934c0,.1-.068,1.3-.13,3.247-.341,10.7-1.173,44.064-1.173,44.064H349s1.671-39.513,2.633-48.73c1.221-11.761,8.937-61.515,8.937-61.515Z",
    transform: "translate(-269.011 -119.149)",
    fill: "#8b9a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M383.275,255.675q1.187-20.2,3.568-40.3c.9-7.545,1.985-15.07,3.063-22.6,0-.061.109-.061.1,0-1.985,13.4-3.411,26.9-4.6,40.387s-2.047,26.975-2.606,40.482c-.314,7.661-.553,15.322-.8,22.977a.143.143,0,0,1-.287,0C382.061,282.963,382.457,269.319,383.275,255.675Z",
    transform: "translate(-279.409 -120.14)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M351.323,345.025c.682-.089,8.473-.2,11.468-.2,2.558,0,10.588.2,11.468.2.068,0,.061.068,0,.082-1.051.164-5.621.287-10.526.287-2.988,0-12.021-.211-12.409-.259a.055.055,0,0,1,0-.1Z",
    transform: "translate(-269.738 -168.662)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M389.195,189.58s-6.283,62.149-6.426,62.934c0,.1-.068,1.3-.13,3.247L370.55,189.587Z",
    transform: "translate(-275.859 -119.028)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M399.745,366.754c1.317.075,35.782-9.285,36.839-10.472.416-.45-.682-5.546-2.122-11.673-.314-1.323-.594-2.729-1-4.093-.512-1.712-1.044-3.411-1.583-5.069-2.3-7.143-4.516-13.057-4.516-13.057l-21.831,5.86,3.889,12.962,1.59,5.321,1.2,4.018s-11.6,9.483-12.648,10.915S398.435,366.672,399.745,366.754Z",
    transform: "translate(-284.827 -161.61)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M436.618,367.77c-1.085,1.187-35.55,10.547-36.873,10.472s-1.18-3.834-.136-5.26c.641-.866,5.151-4.7,8.6-7.573-1,1.173-2.551,3.172-2.047,3.7,1.323,1.3,22.793-4.775,28.885-10.567C436.222,363.527,436.973,367.381,436.618,367.77Z",
    transform: "translate(-284.833 -173.118)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M365.93,189.551s1.692,8.971,7.955,13.542c0,0,8.821,48.5,9.933,53.983,2.156,10.663,11.236,41.1,11.236,41.1l26.183-8s-11.3-36.73-12.812-40.585c-.826-2.1-7.156-42.3-7.027-43.245,1.542-11.482-3.909-16.857-3.909-16.857Z",
    transform: "translate(-274.391 -119.114)",
    fill: "#8b9a4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M396.277,192.481a8.534,8.534,0,0,0,3.138,4.5,10.6,10.6,0,0,0,5.7,1.951.277.277,0,0,1,0,.553c-4.175,0-8.4-2.647-9.012-6.979A.091.091,0,0,1,396.277,192.481Z",
    transform: "translate(-283.979 -119.846)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M371.668,205.259a23.2,23.2,0,0,1,4.318,2.292c1.433.887,2.729,1.924,4.148,2.886a.055.055,0,0,1-.055.089c-1.446-.832-2.961-1.562-4.4-2.422a27.368,27.368,0,0,1-4.093-2.729C371.559,205.327,371.607,205.238,371.668,205.259Z",
    transform: "translate(-276.186 -123.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M370.8,192.472c.225.955.5,1.9.75,2.852s.423,1.8.682,2.681a4.666,4.666,0,0,0,1.364,2.217c.368.307.771.58,1.16.866l.682.45a1.649,1.649,0,0,0-.1-.382c-.082-.362-.157-.73-.239-1.092-.171-.8-.341-1.617-.5-2.429-.321-1.59-.621-3.2-1.023-4.775a.048.048,0,0,1,.1,0c.471,1.555.982,3.09,1.405,4.659.2.764.989,4.578,1.03,4.85s.075.559.1.839a3.32,3.32,0,0,1,.041.86c0,.075-.1.068-.13,0h0a3.411,3.411,0,0,1-.28-.819c-.082-.273-.157-.546-.218-.825l-.061-.3c-.389-.218-.757-.5-1.119-.744s-.791-.512-1.167-.8a4.352,4.352,0,0,1-1.48-2.088,16.2,16.2,0,0,1-.58-2.729c-.171-1.085-.307-2.176-.512-3.254C370.7,192.431,370.791,192.4,370.8,192.472Z",
    transform: "translate(-275.91 -119.856)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M409.916,337.626c.621-.28,8.05-2.661,10.915-3.534,2.456-.744,10.192-2.893,11.031-3.152.061,0,.082.048,0,.075-.955.464-5.287,1.91-9.981,3.336-2.865.873-11.563,3.309-11.952,3.377a.055.055,0,0,1-.014-.1Z",
    transform: "translate(-288.36 -164.232)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M424.454,266.214c-1.037-3.015-2.088-6.024-3.1-9.046a71.634,71.634,0,0,1-2.422-9.067c-1.248-6.263-2.326-12.573-3.343-18.884q-.764-4.775-1.453-9.605-.327-2.374-.648-4.775c-.2-1.542-.457-3.077-.539-4.632-.314-5.744,1.733-11.816-.764-17.3a9.639,9.639,0,0,0-1.023-1.733c-.034-.048-.116,0-.082.055,3.329,5.205,1.5,11.529,1.405,17.267a60.1,60.1,0,0,0,.921,9.374q.682,4.707,1.412,9.4,1.453,9.421,3.206,18.8a76.982,76.982,0,0,0,2.088,9.107c.948,3.015,2.047,5.99,3.07,8.978,2.1,6.038,7.5,21.148,7.77,21.913,0,.061.13.034.1-.034C429,279.974,426.542,272.285,424.454,266.214Z",
    transform: "translate(-288.736 -119.605)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M359.44,133.968c-6,6.338-20.582,13.385-25.392,13.385-5.458,0-14.695-7.607-21.626-14.019-1.521-1.405,7.852-15.2,9.551-13.753,4.2,3.623,14.019,13.515,15.541,13.753,2.224.348,11.188-2.047,18.29-4.052C363.677,127.037,362.49,130.748,359.44,133.968Z",
    transform: "translate(-257.334 -96.383)",
    fill: "#e8c0bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M313.823,127.288c1.958,0,6.965-11.884,5.976-13.644a7.75,7.75,0,0,0-1.364-1.487h0a28.687,28.687,0,0,1-2.483-7.927c-.416-3.3-.648-8.248-2.435-8.091-2.6.218-3.049,6.515-3.09,10.144a11.709,11.709,0,0,0-4.325-1.746c-3.513-.225-6.508,15.329-3.861,17.737S311.865,127.295,313.823,127.288Z",
    transform: "translate(-253.829 -88.966)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M294.865,126.577s3.882.682,5.792-1.317c5.962-6.235-.8-25.712-4.093-24.921s-6.474,13.119-6.474,13.119Zm.15-1.9L291.3,114.44s2.633-10.731,5.192-11.345,7.675,15.691,3.029,20.541c-1.487,1.576-4.5,1.023-4.5,1.023Z",
    transform: "translate(-250.29 -90.295)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M247.667,124.59l1.194,6.051-5.171,3.009Z",
    transform: "translate(-235.544 -98.009)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M273.948,142.115l20.282-8.978-16.6-28.557-12.962,5.874Z",
    transform: "translate(-242.212 -91.65)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M276.4,103.131l1.105-3.111L260.8,107.21,263.44,109Z",
    transform: "translate(-240.982 -90.201)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M264.473,134.855l2.176,7.436-17.239-8.753,1-2.108Z",
    transform: "translate(-237.362 -100.182)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M244.184,127.942c-1.9-1.842-6.024-2-6.044-.252,0,.962,1.474,1.235,3.275.553a5.608,5.608,0,0,1,2.77-.3Z",
    transform: "translate(-233.781 -98.605)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M241.947,137.71c-1.528.682-2.62,3.009-1.617,3.411.559.239,1.078-.553,1.119-1.76A3.513,3.513,0,0,1,241.947,137.71Z",
    transform: "translate(-234.354 -102.178)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M239.93,132.935a7.375,7.375,0,0,0-5.778,1.276c-2.149,1.555-3.411,4.775-1.364,5.574.791.334,1.91-.341,2.777-1.61C236.88,136.216,237.631,133.7,239.93,132.935Z",
    transform: "translate(-231.75 -100.616)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M309.63,108.767c.525,1.753-1.842,1.364-1.842,1.364s3.268,1.364,3.1,3.411-3,1.364-3.206,1.364c.177.075,3.145,1.426,2.777,3.411s-3.145,1.023-3.322.955c.143.123,1.972,1.76,1.364,3.22-1.085,2.511-5.881-1.549-8.077-1.269,0,0,.048,3.773,0,3.882,0,0-4.639-3.766-4.85-6.754a1.917,1.917,0,0,1,1.364-1.985,2.935,2.935,0,0,1-1.364-2.64c.123-.812,1.542-1.364,1.542-1.364a2.4,2.4,0,0,1-.969-2.292c.239-1.119,1.63-1.474,1.63-1.474a2.851,2.851,0,0,1-.211-2.49C298.762,103.957,308.518,105,309.63,108.767Z",
    transform: "translate(-252.024 -91.784)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M299.043,110.045s-.034-.048,0-.048a16.994,16.994,0,0,1,9.981,1.678c.1.055.055.232-.061.2a34.793,34.793,0,0,0-9.919-1.828Z",
    transform: "translate(-253.13 -93.322)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M297.71,115.66v-.068a15.923,15.923,0,0,1,10.772,2.517c.109.075.136.252,0,.171C306.265,116.956,300.882,115.735,297.71,115.66Z",
    transform: "translate(-252.711 -95.11)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M308.008,124.659a21.613,21.613,0,0,0-10.233-3.165c-.048,0-.041-.068,0-.075a14.379,14.379,0,0,1,5.935.628,9.817,9.817,0,0,1,4.387,2.5C308.151,124.6,308.076,124.7,308.008,124.659Z",
    transform: "translate(-252.721 -96.965)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M310.1,112.48c.116.061-.1.164,0,.232.478.273,3.213,2.2,2.845,3.336-.293.907-1.726,1.139-2.306,1.016l-1.467-.314,1.269.805a6.091,6.091,0,0,1,1.494,1.31,2.19,2.19,0,0,1,.566,1.7,1.242,1.242,0,0,1-1.119,1.112,3.766,3.766,0,0,1-1.869-.327l-1.644-.682,1.323,1.173a5.78,5.78,0,0,1,.969,1.105,2.347,2.347,0,0,1,.45,1.3,1.119,1.119,0,0,1-.621,1.01,2.476,2.476,0,0,1-1.4.041,19.785,19.785,0,0,1-2.927-.955c-.484-.184-.976-.368-1.474-.532a3.622,3.622,0,0,0-1.542-.239,3.957,3.957,0,0,1,1.494.375c.478.2.948.416,1.419.634a16.414,16.414,0,0,0,2.94,1.139,2.9,2.9,0,0,0,1.671,0,1.6,1.6,0,0,0,.982-1.46,2.907,2.907,0,0,0-.518-1.617,6.37,6.37,0,0,0-1.057-1.248l-.321.491a4.318,4.318,0,0,0,2.21.409,1.8,1.8,0,0,0,1.105-.532,2.047,2.047,0,0,0,.518-1.1,2.729,2.729,0,0,0-.716-2.156,6.761,6.761,0,0,0-1.665-1.419l-.2.491a2.773,2.773,0,0,0,3-1.3C314.1,114.4,310.741,112.739,310.1,112.48Z",
    transform: "translate(-254.281 -94.16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M313.49,111.211a3.664,3.664,0,0,0,1.105-.2.853.853,0,0,0,.573-.641,1.794,1.794,0,0,0-.225-.955,11.533,11.533,0,0,0-.573-1.01,2.92,2.92,0,0,1,.914.8,1.712,1.712,0,0,1,.389,1.248,1.262,1.262,0,0,1-.348.641,1.289,1.289,0,0,1-.621.3A1.972,1.972,0,0,1,313.49,111.211Z",
    transform: "translate(-257.726 -92.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M325.33,120.19,319.19,142.2s11.529,5.84,16.414,5.942,18.931-6.4,26.552-13.972c2.94-2.927,3.411-6.924-3.773-5.164s-17.089,3.779-17.84,3.629S325.33,120.19,325.33,120.19Z",
    transform: "translate(-259.538 -96.61)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M331.017,125.548c-.553,1.542-.955,3.152-1.364,4.728s-.86,3.165-1.269,4.775c-.8,3.179-1.528,6.385-2.224,9.592a.055.055,0,0,0,.1,0c.935-3.152,1.835-6.31,2.654-9.49q.614-2.381,1.167-4.775c.368-1.6.791-3.2,1.044-4.816a.055.055,0,1,0-.109-.014Z",
    transform: "translate(-261.753 -98.298)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M365.7,157.79l-1.6,16.666s28.127-.976,34.793-1.774c0,0-8.1-30.611-15.691-38.081-3.793-3.732-8.009-3.234-10.567-.368-.682.723-8.262,11.87-8.916,16.018C363.161,153.915,365.7,157.79,365.7,157.79Z",
    transform: "translate(-273.662 -100.346)",
    fill: "#070a5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M387.689,96.906c.887,1.3,7.573,4.468,11.065-1.242s-3.739-12.887-9.367-8.869A7.292,7.292,0,0,0,387.689,96.906Z",
    transform: "translate(-280.889 -85.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M384.327,129.753c-.184.553-3.22,3.984-5.8,3.629-.839-.123-.4-4.728-.4-4.728l-.041-.348-.634-4.871,5.928-3.084.853-.4s.089,1.364.177,3.015v.512l.041.757v1.194A31.332,31.332,0,0,1,384.327,129.753Z",
    transform: "translate(-278.052 -96.534)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M384.409,122.965a9.844,9.844,0,0,1-6.324,5.342l-.634-4.871,5.928-3.084.853-.4S384.32,121.294,384.409,122.965Z",
    transform: "translate(-278.052 -96.534)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M368.86,108.695c-1.555,8.473,3.343,10.363,5.171,10.7,1.658.3,7.341,1.119,9.769-7.143s-1.023-11.673-4.775-12.566S370.381,100.235,368.86,108.695Z",
    transform: "translate(-275.227 -90.02)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M371,110.666a5.641,5.641,0,0,0,.573-.048.969.969,0,0,0,.594-.177.307.307,0,0,0,.041-.368.75.75,0,0,0-.723-.259,1.112,1.112,0,0,0-.744.314.327.327,0,0,0,.259.539Z",
    transform: "translate(-275.896 -93.308)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M378.955,111.826c-.2-.048-.368-.123-.566-.191a.948.948,0,0,1-.539-.3.3.3,0,0,1,.048-.368.764.764,0,0,1,.764-.1,1.112,1.112,0,0,1,.648.471.327.327,0,0,1-.355.484Z",
    transform: "translate(-278.166 -93.63)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M377.275,114.91s.041,0,.041.055c-.1.58-.116,1.262.382,1.528h0C377.05,116.336,377.091,115.442,377.275,114.91Z",
    transform: "translate(-277.959 -94.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M377.891,114.12c.948.061.764,1.944-.109,1.89S377.1,114.072,377.891,114.12Z",
    transform: "translate(-277.975 -94.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M378.673,114.314c.157.123.3.327.5.368s.416-.136.587-.314h0a.684.684,0,0,1-.594.73c-.389.048-.58-.327-.634-.682C378.544,114.362,378.612,114.266,378.673,114.314Z",
    transform: "translate(-278.395 -94.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M372.26,114.13a.047.047,0,0,0-.048.048c0,.587-.171,1.255-.682,1.364h0C372.151,115.576,372.321,114.724,372.26,114.13Z",
    transform: "translate(-276.171 -94.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M371.525,113.166c-.935-.157-1.18,1.726-.314,1.869S372.3,113.3,371.525,113.166Z",
    transform: "translate(-275.9 -94.375)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M370.854,113.178c-.164.075-.334.239-.512.232s-.334-.239-.437-.45h-.034c-.055.355,0,.744.348.86s.58-.177.682-.525C370.956,113.253,370.915,113.144,370.854,113.178Z",
    transform: "translate(-275.638 -94.313)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M376.342,121.558c-.143.13-.293.314-.512.321a1.549,1.549,0,0,1-.621-.177h0a.8.8,0,0,0,.73.355.621.621,0,0,0,.484-.491S376.363,121.544,376.342,121.558Z",
    transform: "translate(-277.34 -97.044)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M373.159,115.458s-.211.853-.259,1.269a.587.587,0,0,0,.232.089h0a1.958,1.958,0,0,0,1.972-.525c.034,0,0-.082-.055-.061a2.974,2.974,0,0,1-1.835.321c0-.116.416-1.46.348-1.474a3.506,3.506,0,0,0-.955.116c.4-1.8,1.078-3.527,1.446-5.321a.061.061,0,0,0-.109-.041,30.018,30.018,0,0,0-1.794,5.662C372.108,115.724,372.988,115.505,373.159,115.458Z",
    transform: "translate(-276.367 -93.311)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M373.69,119.48a2.353,2.353,0,0,0,.778.941,1.078,1.078,0,0,0,.628.184c.491,0,.6-.437.6-.825a2.936,2.936,0,0,0-.082-.6A3.145,3.145,0,0,1,373.69,119.48Z",
    transform: "translate(-276.857 -96.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M374.83,120.692a1.078,1.078,0,0,0,.628.184c.491,0,.6-.437.6-.825A1.119,1.119,0,0,0,374.83,120.692Z",
    transform: "translate(-277.22 -96.56)",
    fill: "#fccfca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M384.1,111.523a3.527,3.527,0,0,1-1.862-2.954,9.148,9.148,0,0,1-3.629-3.131c.055.177.423,1.46.628,2.108a9.469,9.469,0,0,1-6.9-5.389,9.292,9.292,0,0,0-2.476,3.35,10.392,10.392,0,0,1,1.856-5.458c5.9-7.347,12.389.512,12.389.512a5.261,5.261,0,0,1,2.47,3.411A10.045,10.045,0,0,1,384.1,111.523Z",
    transform: "translate(-275.64 -89.212)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M376.225,108.589a9.947,9.947,0,0,0,2.729,1.112h0a8.4,8.4,0,0,1-3.882-2.531,8.1,8.1,0,0,1-1.112-1.671,5.458,5.458,0,0,1-.648-2.047c0-.055-.082-.048-.082,0a6.568,6.568,0,0,0,.355,2.149,6.057,6.057,0,0,0,1.139,1.828,6.9,6.9,0,0,0,1.494,1.208",
    transform: "translate(-276.711 -91.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M388.376,116.861s2.128-2.5,3.275-1.712-.628,4.53-2.1,4.926a1.46,1.46,0,0,1-1.869-.969Z",
    transform: "translate(-281.303 -94.96)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M391.481,116.77v.041a3.691,3.691,0,0,0-2.115,2.115.812.812,0,0,1,1.221-.109s0,.061-.034.055a.894.894,0,0,0-1.01.218,3.985,3.985,0,0,0-.546.75c-.055.082-.211,0-.171-.082h0C388.943,118.462,390.1,116.77,391.481,116.77Z",
    transform: "translate(-281.666 -95.524)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M387.157,132.74a104.716,104.716,0,0,0-.982,27.493c2.633,30.079,10.1,74.518,11.891,77.465,2.729,4.523,31.341,7.429,31.341,7.429a642.143,642.143,0,0,0-22.26-74.217s-5.867-16.932-7.948-21.449C391.373,132.542,387.157,132.74,387.157,132.74Z",
    transform: "translate(-280.685 -100.599)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M419.286,224.85a67.586,67.586,0,0,1-8,1.937c-3.786.614-7.613.853-8.7,1.01-.1,0-.1.341,0,.341,1.439-.048,5.86-.314,8.753-.778a45.963,45.963,0,0,0,7.77-2.047c.116.8.211,1.433.341,2.231a48.5,48.5,0,0,1-16.107,2.947c-.075-.334-.321-2.129-.471-2.606,0-.075-.334-.034-.327.082,0,.491.5,4.816.641,5.69.334,2.156,1.453,8.186,2.176,9.305,1.644,2.47,6.822,1.637,8.275,1.419s6.092-.826,7.559-2.8c.778-1.057.184-6.017-.682-10.349C420.118,229.189,419.415,224.87,419.286,224.85Zm-5.349,18.945c-4.591.744-6.74.109-7.6-.737-1.01-.982-1.364-2.92-1.8-5.055-.321-1.678-1.112-6.972-1.139-7.081a43.355,43.355,0,0,0,16.114-2.818c.416,2.5.744,4.5,1.153,7.013.293,1.815.682,4.871-.082,6.078C419.954,242.205,417.253,243.256,413.937,243.795Z",
    transform: "translate(-286.016 -130.259)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M412.638,218.045c.853,2.483-.082,6.467,1.876,6.406,1.746-.055,2.122-2.879,2.122-2.879s.6,3.322,2.456,2.729,1.644-3.773,1.644-3.773.375,2.783,2.183,2.047,2.122-3.459,2.122-3.459.682.723,1.706-.362c1.5-1.555.86-6.181-.041-8.521S420.75,200,419.952,198.82l-15.043,5.69s-.3,4.9-.157,7.4,2.927,10.615,4.987,10.063,0-6.249-.2-7.757.116-1.808.73-1.194A30.666,30.666,0,0,1,412.638,218.045Z",
    transform: "translate(-286.716 -121.923)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M421.09,227.676c.252-3.97-.327-5.751-2.2-9.183-.034-.068.055-.136.1-.075,2.142,3.2,3.186,5.328,2.292,9.278C421.24,227.854,421.076,227.826,421.09,227.676Z",
    transform: "translate(-291.218 -128.173)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M427.005,226.253a20.6,20.6,0,0,0-2.415-9.817c0-.055.068-.1.1-.048,1.978,3.527,2.968,5.676,2.524,9.831C427.189,226.4,427.005,226.445,427.005,226.253Z",
    transform: "translate(-293.033 -127.524)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M433.017,224a18.67,18.67,0,0,0-3.077-9.551.075.075,0,1,1,.123-.082A13.346,13.346,0,0,1,433.14,224C433.126,224.227,433.044,224.254,433.017,224Z",
    transform: "translate(-294.726 -126.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M393.507,138.68c8.923,12.109,20.65,37.678,22.185,41.772,1.044,2.77-14.777,8.4-15.206,6.406-.539-2.545-8.9-34.486-11.134-46.322C388.125,134.013,391.3,135.685,393.507,138.68Z",
    transform: "translate(-281.748 -101.647)",
    fill: "#f7d6d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M397.186,182.1,415.7,177.47s-16.953-32.971-21.633-39.118c-4.775-6.249-5.635-2.729-4.775,3.97C390.268,149.554,397.186,182.1,397.186,182.1Z",
    transform: "translate(-281.722 -101.347)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M417.477,194.26c-1.262.15-2.517.484-3.759.75s-2.5.546-3.738.832c-2.49.573-4.98,1.16-7.436,1.856a.055.055,0,0,0,0,.1c2.517-.437,5.014-1,7.5-1.569,1.221-.28,2.435-.573,3.65-.866s2.558-.559,3.786-.976a.068.068,0,0,0-.007-.13Z",
    transform: "translate(-286.015 -120.432)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M399.412,186.09c-.348,0-1.76.157-1.815.177,0-.177-.921-6.072-1.167-7.293-.478-2.388-.989-4.775-1.487-7.156-1.016-4.823-2.094-9.633-3.145-14.449-.594-2.729-1.208-5.41-1.869-8.1,0-.061-.109-.034-.1.034.28,1.576.573,3.145.88,4.721-.293-.682-.6-1.364-.866-2.047,0-.061-.13,0-.1,0,.28.682.518,1.439.778,2.156.136.382.287.757.443,1.126.559,2.845,1.146,5.683,1.726,8.521.982,4.83,1.951,9.667,3.015,14.483.293,1.323,1.576,8.391,1.624,8.378s1.808-.389,2.135-.525C399.467,186.151,399.467,186.083,399.412,186.09Z",
    transform: "translate(-281.956 -106.032)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M369.16,134.06s-5.082,6.7-6.577,27.786c-1.617,22.752-5.069,72.048-5.335,73.794s-7.388,5.826-7.388,5.826l10.963-82.929s-2.047-4.093-1.678-7.1C359.6,147.424,367.195,134.954,369.16,134.06Z",
    transform: "translate(-269.284 -101.018)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M368.889,144.74a24.589,24.589,0,0,0-1.419,2.244l.082-.273c.13-.4.232-.8.327-1.214,0,0-.034-.041-.048,0-.143.4-.287.8-.4,1.2l-.2.682h0c-.273.45-1.146,2.367-1.364,2.824-.034.061.068.116.1.055.218-.471,1.3-2.279,1.542-2.729.471-.935,1-1.842,1.474-2.783Z",
    transform: "translate(-274.369 -104.412)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M375.006,134.06q-2.517,3.281-5.069,6.542v-.177l1.317,1.18.1.1-.1.109-2.729,3.1.041-.1v8.521c0,2.838-.068,5.683-.143,8.521-.082-2.838-.123-5.683-.15-8.521s-.034-5.683,0-8.521v-.061l.034-.048,2.729-3.077v.2l-1.289-1.2-.089-.082.075-.1Q372.352,137.225,375.006,134.06Z",
    transform: "translate(-275.13 -101.018)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M387.384,132.71q1.364,3.93,2.688,7.88l.048.136h-.143l-2.551.5.1-.13,1.446,3.568h0v.048c-.362,2.729-.778,5.526-1.173,8.282s-.839,5.519-1.3,8.275q.471-4.161,1.017-8.309c.375-2.77.737-5.533,1.146-8.3v.082l-1.419-3.575-.068-.171h.177l2.558-.471-.1.171C388.994,138.024,388.2,135.364,387.384,132.71Z",
    transform: "translate(-280.925 -100.589)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 79.996,
    height: 10.185,
    transform: "translate(70.063 224.808)",
    fill: "#64454f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 69.053,
    height: 10.185,
    transform: "translate(66.434 204.969)",
    fill: "#64454f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M332.017,430.136H326.15L332.2,402.35h11.925Z",
    transform: "translate(-261.749 -187.195)",
    fill: "#553640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M334.324,402.34h11.918l-3.029,6.952h-10.4Z",
    transform: "translate(-263.866 -187.192)",
    fill: "#8b626f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M419.106,430.136h5.867l-6.058-27.786H406.99Z",
    transform: "translate(-287.44 -187.195)",
    fill: "#553640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M420.429,409.292h-10.41l-3.029-6.952h11.925Z",
    transform: "translate(-287.44 -187.192)",
    fill: "#8b626f"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationImage);
export default __webpack_public_path__ + "static/media/authentication_image.d191b0f9.svg";
export { ForwardRef as ReactComponent };